import { Navigate, Route, Routes } from "react-router";
import { useEffect, useState } from "react";
import { getToken } from "./lib/api";
import LoginPage from "./pages/login";
import PortalShell from "./pages/portal";
import DashboardPage from "./pages/dashboard";
import ContactsPage from "./pages/contacts";
import ListsPage from "./pages/lists";
import TemplatesPage from "./pages/templates";
import CampaignsPage from "./pages/campaigns";
import CampaignDetailPage from "./pages/campaign-detail";
import SettingsPage from "./pages/settings";
import UsersPage from "./pages/users";
import ProfilePage from "./pages/profile";
import ReportsPage from "./pages/reports";
import SuppressionPage from "./pages/suppression";
import DomainsPage from "./pages/domains";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const [token, setT] = useState<string | null>(getToken());
  useEffect(() => {
    const tick = () => setT(getToken());
    window.addEventListener("storage", tick);
    return () => window.removeEventListener("storage", tick);
  }, []);
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<RequireAuth><PortalShell /></RequireAuth>}>
        <Route index element={<DashboardPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="lists" element={<ListsPage />} />
        <Route path="templates" element={<TemplatesPage />} />
        <Route path="campaigns" element={<CampaignsPage />} />
        <Route path="campaigns/:id" element={<CampaignDetailPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="suppression" element={<SuppressionPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="domains" element={<DomainsPage />} />
        <Route path="profile" element={<ProfilePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
